import React from 'react';
import SEOMeta from 'containers/SEOMeta';
import withPDFView from 'components/hoc/withPDFView';
import Article from './containers/Article';
import ArticleRelated from './containers/ArticleRelated';
import ArticleSinglePDF from './pdf';
import { selectors } from './ducks/article.duck';

const ArticleSingle = () => (
  <div className="l-article">
    <SEOMeta selector={selectors.data} />
    <main className="l-article__main">
      <Article />
    </main>
    <aside className="l-article__aside">
      <div className="l-article__aside-inner">
        <ArticleRelated />
      </div>
    </aside>
  </div>
);

export default withPDFView(
  ArticleSinglePDF,
)(ArticleSingle);
